export enum InternalIcon {
  InnovationSpace = 'icon-innovation-space',
  SIGlobeCursor = 'switzerland-innovation-globe-cursor',
  UserFollow = 'user-follow',
  CommentDots = 'comment-dots',
  Calendar = 'calendar',
  Home = 'home',
  Lightbulb = 'lightbulb',
  News = 'news',
  Organization = 'organization',
  Unicorn = 'unicorn',
  JipLogo = 'jip-logo',
  Forward = 'icon-forward',
  CCIcon = 'icon-cc',
  Exclamation = 'triangle-exclamation',
  PaperPlaneTop = 'paper-plane-top',
  CopyLink = 'copy-link',
}

export enum IconType {
  SVG = 'svg',
  PNG = 'png',
  GIF = 'gif',
}
